import React from 'react';
import { connect } from 'react-redux';
import { SharedVideo } from '../../shared-video/components/web';

import { OverflowMenuItem } from '../../base/toolbox/components';
import { shouldDisplayTileView, toggleTileView } from '../../video-layout';
import { IconGalleryView, IconPinnedView } from '../../base/icons';
import { Captions } from '../../subtitles/';
import { LargeVideo, _connect } from './LargeVideo.web';

declare var APP: Object;
declare var interfaceConfig: Object;

class RPC_LargeVideo extends LargeVideo {
    constructor(props) {
        super(props);
        this._doToggleTileView = this._doToggleTileView.bind(this);
    }
    _doToggleTileView() {
        APP.store.dispatch(toggleTileView());
    }

    render() {
        const {
            _isChatOpen,
            _noAutoPlayVideo,
            _whiteboardOpen
        } = this.props;
        const style = this._getCustomSyles();
        const className = `videocontainer${_isChatOpen ? ' shift-right' : ''}`;

        return (
            <div
                className = { className }
                id = 'largeVideoContainer'
                style = { style }>
                <SharedVideo />
                <div id = 'etherpad' />

                { !_whiteboardOpen && <OverflowMenuItem
                    accessibilityLabel = { 'toolbar.accessibilityLabel.fullScreen' }
                    icon = { this.props._tileViewEnabled ? IconPinnedView : IconGalleryView }
                    key = 'fullscreen'
                    onClick = { this._doToggleTileView }
                    text = { this.props._tileViewEnabled ? 'Speaker View' : 'Gallery View' } /> }

                <div id = 'dominantSpeaker'>
                    <div className = 'dynamic-shadow' />
                    <div id = 'dominantSpeakerAvatarContainer' />
                </div>
                <div id = 'remotePresenceMessage' />
                <span id = 'remoteConnectionMessage' />
                <div id = 'largeVideoElementsContainer'>
                    <div id = 'largeVideoBackgroundContainer' />

                    {/*
                      * FIXME: the architecture of elements related to the large
                      * video and the naming. The background is not part of
                      * largeVideoWrapper because we are controlling the size of
                      * the video through largeVideoWrapper. That's why we need
                      * another container for the background and the
                      * largeVideoWrapper in order to hide/show them.
                      */}
                    <div id = 'largeVideoWrapper'>
                        <video
                            autoPlay = { !_noAutoPlayVideo }
                            id = 'largeVideo'
                            muted = { true }
                            playsInline = { true } /* for Safari on iOS to work */ />
                    </div>
                </div>
                { interfaceConfig.DISABLE_TRANSCRIPTION_SUBTITLES
                    || <Captions /> }
            </div>
        );
    }
}

function _mapStateToProps(state) {
    const { isOpen: _whiteboardOpen } = state['features/whiteboard'];
    return {
        _whiteboardOpen,
        _tileViewEnabled: shouldDisplayTileView(state),
    };
}

const _mapDispatchToProps = {};

export default _connect(connect(_mapStateToProps, _mapDispatchToProps)(RPC_LargeVideo));